/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getOwnerTypesList } from '../fn/owner-type-controller/get-owner-types-list';
import { GetOwnerTypesList$Params } from '../fn/owner-type-controller/get-owner-types-list';
import { OwnerTypeWithRelations } from '../models/owner-type-with-relations';

@Injectable({ providedIn: 'root' })
export class OwnerTypeControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `ownerTypeControllerGetOwnerTypesList()` */
  static readonly OwnerTypeControllerGetOwnerTypesListPath = '/owner-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOwnerTypesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOwnerTypesList$Response(params?: GetOwnerTypesList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OwnerTypeWithRelations>>> {
    return getOwnerTypesList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOwnerTypesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOwnerTypesList(params?: GetOwnerTypesList$Params, context?: HttpContext): Observable<Array<OwnerTypeWithRelations>> {
    return this.getOwnerTypesList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OwnerTypeWithRelations>>): Array<OwnerTypeWithRelations> => r.body)
    );
  }

}
